import { useMutation } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { CreateAnalysisBodyDtoType, schemas } from '@convergence/client';

export const useCreateAndLaunchAnalysisMutation = () => {
  const mutation = useMutation({
    mutationKey: ['createAndLaunchAnalysis'],
    mutationFn: async (args: CreateAnalysisBodyDtoType) => {
      return fetch(
        '/analysis',
        {
          method: 'post',
          body: JSON.stringify(args)
        },
        schemas.CreateAndLaunchAnalysisResponseDto
      );
    },
    retry: false
  });

  return mutation;
};
